import { useRoleLayout } from "../hooks/useRoleLayout";

const SubUserEdit = () => {
  const { Layout: RoleLayout } = useRoleLayout();
  return (
    <RoleLayout>
      <div>SubUserEdit permissions</div>
    </RoleLayout>
  );
};

export default SubUserEdit;
